import useEnv from '../composables/useEnv'
import useRestNode from '../composables/useRestNode'
import usePlan from '../composables/usePlan'

/**
 * Composition function for providing better choice context.
 */
export default function useBetterChoiceService() {

    const { get } = useRestNode()


    /**
     * Determines whether betterChoice designation is available for a network and employerGroup.  It also returns data that
     * help to indicate which kinds of organizations apply.
     */
    const getBadgeAvailability = async (networkId, employerGroupId, asOfDate) => {
        const { networkServiceEndpoint } = useEnv()
        const url = new URL(`${networkServiceEndpoint}/badge-availability/network/${networkId}/employerGroupId/${employerGroupId}`)
        //console.log('Badge URL:', url.toString())
        if (asOfDate) {
        url.searchParams.append('asof', asOfDate)
        }

        const results = await get(url.toString())
        return results
    }

    /**
     * This function is used to determine the type of institutions that the betteChoice category applies to.
     * It will be used by the UI to determine whether to display a betterChoice alert and which flavor to
     * apply.
     */
    const getRecommendedBadgeType = async (profile, context, betterChoiceContext) => {
        if (!betterChoiceContext) return null
        const { getPlan } = usePlan(profile, context)
        const { networkId, coverageInfo } = getPlan()

        try {
            const result = await getBadgeAvailability(networkId, coverageInfo ? coverageInfo.groupNumber : null, context.asOfDate ? context.asOfDate : null)
            const badge = result.value ? result.value.find((a) => a.badgeFor == betterChoiceContext) : null
            if (!badge) return null

            if (badge.availableForClinics && badge.availableForHospitals) return 'both'
            if (badge.availableForClinics) return 'clinic'
            if (badge.availableForHospitals) return 'hospital'
            return null
        }
        catch(error) {
            console.log("Error occurred while trying to obtain reccommended badgeType from useBetterChoiceService")
            console.log(error)
            return null
        }
    }

    /**
     * This variable may seem a little strange.  Basically, we are just creating an object of functions - the functions
     * defined inside this composition function.  We return the functions as the return value on the composition function.
     * Notice in the searchForProcedures and getBetterChoiceContext functions above, we reference the functions variable
     * when making internal function calls.  This is a pattern that allows us to mock out the internal functions within
     * jest unit tests which makes unit testing much easier and does not require nearly as much data setup and confusion.
     *
     * The downside is that it creates another layer of abstraction inside the implementation here in the composition
     * function and maybe some questions of - 'Why are they doing it that way?'.  This pattern is helpful for unit testing
     * but a little less readable?  We can talk about which we value more.
     */
    const functions = { getBadgeAvailability, getRecommendedBadgeType }

    return functions
}